
export default class LeftContentContainer {
	constructor(
		private emit: (action: 'notNow' | 'accept') => void,
	) {}
	public accept(): void {
		this.emit('accept');
	}

	public notNow(): void {
		this.emit('notNow');
	}
}